import { render, staticRenderFns } from "./AccountDocumentIndex.vue?vue&type=template&id=46a68bec"
import script from "./AccountDocumentIndex.vue?vue&type=script&lang=js"
export * from "./AccountDocumentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports